// import { Meter, Second } from "./base-units";
import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Foot, Mile, Kilometer } from "./length";
import { Minute, Hour } from "./duration";
/** The metric unit for velocity quantities ( <code>m/s</code> ). */
export var MeterPerSecond = UnitDivide.lengthByDuration("MeterPerSecond", BaseUnits.Meter, BaseUnits.Second);
// Velocity
export var FeetPerSecond = UnitDivide.lengthByDuration("FeetPerSecond", Foot, BaseUnits.Second);
export var FeetPerMinute = UnitDivide.lengthByDuration("FeetPerMinute", Foot, Minute);
export var MilesPerHour = UnitDivide.lengthByDuration("MilesPerHour", Mile, Hour);
export var KilometerPerHour = UnitDivide.lengthByDuration("KilometerPerHour", Kilometer, Hour);
export var MeterPerHour = UnitDivide.lengthByDuration("MeterPerHour", BaseUnits.Meter, Hour);
//# sourceMappingURL=velocity.js.map